import axios from 'axios'

export const legacyInstance = axios.create({
  baseURL: process.env.REACT_APP_LEGACY_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
